// Main navigation: mobile menu and submenu toggles

const desktop = window.matchMedia('(min-width: 1100px)');

function closeSubmenus(header, except = null) {
    header.querySelectorAll('.nav_item--open').forEach((item) => {
        if (item !== except) {
            item.classList.remove('nav_item--open');
            item.querySelector('.nav_toggle')?.setAttribute('aria-expanded', 'false');
        }
    });
    header.classList.toggle('header--sub-open', !!except && desktop.matches);
}

function setMobileMenu(header, open) {
    const burger = header.querySelector('.header_burger');
    const nav = header.querySelector('.nav');
    burger.setAttribute('aria-expanded', open ? 'true' : 'false');
    nav.classList.toggle('nav--open', open);
    document.body.classList.toggle('nav-open', open);
}

export function initNavigation() {
    const header = document.querySelector('.header');
    if (!header) {
        return;
    }

    header.querySelector('.header_burger')?.addEventListener('click', (event) => {
        setMobileMenu(header, event.currentTarget.getAttribute('aria-expanded') !== 'true');
    });

    header.querySelectorAll('.nav_toggle').forEach((toggle) => {
        toggle.addEventListener('click', () => {
            const item = toggle.closest('.nav_item');
            const open = !item.classList.contains('nav_item--open');
            closeSubmenus(header, open ? item : null);
            item.classList.toggle('nav_item--open', open);
            toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
        });
    });

    document.addEventListener('keydown', (event) => {
        if (event.key !== 'Escape') {
            return;
        }
        const openItem = header.querySelector('.nav_item--open');
        closeSubmenus(header);
        openItem?.querySelector('.nav_toggle')?.focus();
        if (!desktop.matches) {
            setMobileMenu(header, false);
        }
    });

    // Close opened submenus when clicking outside of the navigation
    document.addEventListener('click', (event) => {
        if (desktop.matches && !event.target.closest('.nav')) {
            closeSubmenus(header);
        }
    });

    desktop.addEventListener('change', () => {
        closeSubmenus(header);
        setMobileMenu(header, false);
    });
}
